var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[(_vm.plaintext)?_c('span',[_c('span',{domProps:{"innerHTML":_vm._s(_vm.displayText)}}),_vm._v(" "),(_vm.displayText != '')?_vm._t("default"):_vm._e()],2):_c('b-form-checkbox',_vm._g(_vm._b({},'b-form-checkbox',_vm.props,false),_vm.listeners),[_c('span',{ref:"spSlot",staticStyle:{"display":"none"}},[_vm._t("default")],2)]),_c('span')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }